import React, { useEffect, useRef } from 'react';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

import '../styles/ProductCard.scss'


const ProductCard = ({className, src, alt, title, price, text, url}) => {

    const ref = useRef();

    useEffect(() => {

        const element = ref.current;
        gsap.set(ref.current, {
            y: 50,
            opacity: 0,
        });
        gsap.to(ref.current, {
            duration: 1.5,
            y: 0,
            opacity: 1,
            ease: "power2.out",
            scrollTrigger: {
                trigger: ref.current,
                start: 'top center+=20%',
                normalizeScroll: true,
                ignoreMobileResize: true
                // markers: true,
            }
        });

    }, []);

    return (
        <div className={className} ref={ref}>
            <div className="product__image">
                <div><img src={src} alt={alt} width="312" height="370"/></div>
            </div>
            <div className="product__text">
                <h3 className="product__title">{title}</h3>
                <p className="product__price">&yen;{price}</p>
                <p className="product__expla">{text}</p>
                <a href={url} className="available">ONLINE STORE</a>
                {/* <a>COMING SOON</a> */}
            </div>
        </div>
    )
}

export default ProductCard
